import { render } from "./templateCreator.vue?vue&type=template&id=d15974f2&scoped=true"
import script from "./templateCreator.vue?vue&type=script&lang=js"
export * from "./templateCreator.vue?vue&type=script&lang=js"

import "./templateCreator.vue?vue&type=style&index=0&id=d15974f2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d15974f2"]])

export default __exports__